export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-26-b3d3acf0647768a6be49234e4db0283e.png";